import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

// Specific type used on front end to show specific contact directory component
interface IFileTypeTemporaryFileForClinicians extends IExportableFile {
    ObjectId: string;
    totalPages?: number;
    sizeBytes?: number;
}

class FileTypeTemporaryFileForClinicians extends ExportableFile implements IFileTypeTemporaryFileForClinicians {
    public ObjectId: string;

    constructor(fields: IFileTypeTemporaryFileForClinicians) {
        super(FileType.TemporaryFileForClinicians);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.ObjectId; }

    public get FetchUrl(): string {
        return `api/pdf/fetch/${this.ObjectId}` + apiSettings.buildQueryString({ auth: true });
    }

    public getCleanCopy(): FileTypeTemporaryFileForClinicians {
        let copyConstructor: IFileTypeTemporaryFileForClinicians = {
            ObjectId: this.ObjectId,
            totalPages: this.totalPages,
            sizeBytes: this.sizeBytes,
            date: this.date,
            description: this.description
        };

        return new FileTypeTemporaryFileForClinicians(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        if (this.totalPages)
            return this.totalPages;

        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: this.FetchUrl
        }));
    }
}

export { FileTypeTemporaryFileForClinicians };
